module.exports = __webpack_public_path__ + "assets/img/Travel_map.0a77ceba-ps.png";